(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/admin/react-dialog-wrapper/assets/javascripts/helper.js') >= 0) return;  svs.modules.push('/components/admin/react-dialog-wrapper/assets/javascripts/helper.js');
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _icon;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var dialog = svs.ui.dialog;

var button = function button(_ref) {
  var title = _ref.title,
    callback = _ref.callback;
  return {
    title: title,
    callback: callback ? callback : function () {}
  };
};
var injectToButtonCallbacks = function injectToButtonCallbacks(buttons, closeDialog) {
  buttons.forEach(function (button) {
    var theCallback = button.callback;
    button.callback = function (dialog, form) {
      closeDialog();
      theCallback(dialog, form);
    };
  });
  return buttons;
};

var checkbox = function checkbox(_ref2) {
  var checked = _ref2.checked,
    text = _ref2.text,
    value = _ref2.value;
  return {
    checked: typeof checked === 'boolean' ? checked : false,
    text: text || '',
    type: dialog.message.CHECKBOX,
    value: typeof value === 'boolean' ? value : false
  };
};

var cmsType = {
  CONFIRM: 'confirm',
  ERROR: 'error',
  INFO: 'info',
  DEFAULT: 'default'
};

var icon = (_icon = {}, _defineProperty(_icon, cmsType.CONFIRM, 'checkmark'), _defineProperty(_icon, cmsType.ERROR, 'exclamation-sign'), _defineProperty(_icon, cmsType.INFO, 'information'), _defineProperty(_icon, cmsType.DEFAULT, 'information'), _icon);

var newDialog = function newDialog(_ref3) {
  var area = _ref3.area,
    autoClose = _ref3.autoClose,
    buttons = _ref3.buttons,
    convertToPopup = _ref3.convertToPopup,
    icon = _ref3.icon,
    message = _ref3.message,
    title = _ref3.title,
    type = _ref3.type;
  var theDialog = new dialog.Confirm({
    actions: injectToButtonCallbacks(buttons, function () {
      return theDialog.close();
    }),
    area: area || dialog.area.POPUP,
    autoClose: autoClose || 0,
    branding: "cms dialog-branding-cms-type-".concat(type || 'default'),
    convertToPopup: convertToPopup || false,
    icon: icon,
    message: message || [],
    title: title
  });
  dialog.api.add(theDialog);
  autoClose && setTimeout(function () {
    return theDialog.close();
  }, autoClose);
  if (theDialog.el.parentNode) {
    var outmostElement = theDialog.el.parentNode.parentNode;
    outmostElement.classList.add('dialog-branding-cms-outmost');
    if (area) {
      theDialog.el.classList.add("dialog-branding-cms-".concat(area));
      outmostElement.classList.add("dialog-branding-cms-outmost-area-".concat(area));
    }
  }
  return theDialog;
};

var text = function text(_ref4) {
  var text = _ref4.text;
  return {
    text: text,
    type: dialog.message.TEXT
  };
};

var helper = {
  button: button,
  checkbox: checkbox,
  cmsType: cmsType,
  icon: icon,
  newDialog: newDialog,
  text: text
};
svs.components.dialogWrapper.helper = helper;

 })(window);